import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/wecom-collaboration',
  name: 'wecomCollaboration',
  component: Layout,
  redirect: '/wecom-collaboration/directory',
  meta: {
    title: '企微协同',
    icon: 'i-lucide:briefcase-business',
  },
  children: [
    {
      path: 'directory',
      name: 'wecomDirectory',
      component: () => import('@/views/wecom_collaboration/index.vue'),
      meta: {
        title: '通讯录',
        icon: 'i-lucide:contact-round',
      },
    },
    {
      path: 'customers',
      name: 'wecomCustomers',
      component: () => import('@/views/wecom_collaboration/customers.vue'),
      meta: {
        title: '客户',
        icon: 'i-lucide:users-round',
      },
    },
    {
      path: 'customer-groups',
      name: 'wecomCustomerGroups',
      component: () => import('@/views/wecom_collaboration/customer-groups.vue'),
      meta: {
        title: '客户群',
        icon: 'i-lucide:messages-square',
      },
    },
  ],
}

export default routes
